import { render } from "./techSolutionScreen.vue?vue&type=template&id=5dca6dd6"
import script from "./techSolutionScreen.vue?vue&type=script&lang=js"
export * from "./techSolutionScreen.vue?vue&type=script&lang=js"

import "./techSolutionScreen.vue?vue&type=style&index=0&id=5dca6dd6&lang=scss"

import exportComponent from "F:\\freelance\\web development\\project twelve\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__